import { createRoot } from 'react-dom/client';
import { ModalLayerManagerProvider } from 'dibs-elements/src/ModalContainer/ModalLayerManager.tsx';
import { PdpButtonAbTestProvider } from 'dibs-address-form/exports/PdpButtonAbTestContext.tsx';
export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        selectedSkuId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
        gaLabel,
        page,
        onClose,
        onOpen,
        buttonAbTest,
        stepType,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports.js'
    ).then(({ components, helpers }) => {
        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;
        const root = createRoot(modalContainer, { identifierPrefix: 'offerModal' });

        root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <ModalLayerManagerProvider>
                    <PdpButtonAbTestProvider value={buttonAbTest}>
                        <MakeOfferModal
                            launchOrigin={launchOrigin}
                            environment={environment}
                            itemId={itemId}
                            selectedSkuId={selectedSkuId}
                            pageCurrency={currency}
                            quantitySelected={quantitySelected}
                            shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                            shouldLaunchContactDealer={shouldLaunchContactDealer}
                            gaLabel={gaLabel}
                            page={page}
                            onClose={onClose}
                            onOpen={onOpen}
                            stepType={stepType}
                        />
                    </PdpButtonAbTestProvider>
                </ModalLayerManagerProvider>
            </IntlProvider>
        );
    });
}
